<template>
  <div class="UserInfo">
    <ld-header />
    <div class="userInfoWrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      > 
        <van-cell>
          <div slot="title">
            <h3 class="font20">
              {{ $t('A124','个人资料') }}
            </h3>
            <p class="gray font12 mt5">
              您好，尊敬的{{ empInfo.empName }}
            </p>
          </div>
          <ld-icon
            class="inline-block main-color"
            style="margin-top: 18px;"
            size="52"
            type="iconweibiaoti-"
          />
        </van-cell>

        <van-cell-group class="travel-info">
          <van-cell
            is-link
            :title="$t('A125','公司信息')"
            to="/userCenter/company"
          >
            {{ vipCorp.fullname }}
          </van-cell>

          <van-cell :title="$t('D038','中文姓名')">
            {{ empInfo.empName }}
          </van-cell>

          <van-cell
            is-link
            :title="$t('D039','英文姓名')"
            @click="EditEngNameShow = true"
          >
            {{ empInfo.engName }}
          </van-cell>
        
          <van-cell
            is-link
            :title="$t('D004','身份证')"
            @click="EditIdNumberShow = true"
          >
            {{ empInfo.idNumber }}
          </van-cell>
        
          <van-cell
            is-link
            :title="$t('D005','护照')"
            @click="EditPassportShow = true"
          >
            {{ empInfo.passport || `请填写护照信息` }}
          </van-cell>

          <van-cell
            is-link
            :title="$t('D017','国籍')"
            @click="EditNationShow = true"
          >
            {{ empInfo.nationName }}
          </van-cell>

          <van-cell
            is-link
            :title="$t('D013','出生日期')"
            @click="EditBornShow = true"
          >
            {{ empInfo.born }}
          </van-cell>

          <van-cell
            is-link
            :title="$t('D016','性别')"
            @click="EditSexShow = true"
          >
            <span v-show="empInfo.sex=='M'">{{ $t('D018','男') }}</span>
            <span v-show="empInfo.sex=='F'">{{ $t('D019','女') }}</span>
          </van-cell>

          <van-cell
            title="是否公务员"
            type="text"
            v-model="empInfo.isCivilName"
            is-link
            @click="showCivil=!showCivil"
            input-align="left"
            :readonly="true"
            placeholder="是否公务员"
          />
          <van-action-sheet
            v-model="showCivil"
            :actions="[
              {key:'0',name:'否'},
              {key:'1',name:'是'},
            ]"
            cancel-text="取消"
            @select="civilChange"
          />
          <div v-show="empInfo.isCivil==1">
            <van-cell
              v-show="empInfo.isCivil==1"
              title="验证方式"
              type="text"
              v-model="empInfo.civilCheckName"
              is-link
              @click="showCivilCheck=!showCivilCheck"
              input-align="left"
              :readonly="true"
              placeholder="验证方式"
            />
            <van-action-sheet
              v-model="showCivilCheck"
              :actions="[
                {key:'1',name:'公务卡'},
                {key:'2',name:'预算单位'},
              ]"
              cancel-text="取消"
              @select="civilCheckChange"
            />
            <van-cell
              v-show="empInfo.civilCheck==1"
              title="预算银行"
              type="text"
              is-link
              v-model="empInfo.civilBankName"
              input-align="left"
              :readonly="true"
              @click="showBank=!showBank"
              placeholder="预算银行"
            />
            <van-action-sheet
              v-model="showBank"
              :actions="bankArr"
              cancel-text="取消"
              @select="backChange"
            />
            <van-field
              v-show="empInfo.civilCheck==2"
              label="预算单位"
              type="text"
              clearable
              v-model="empInfo.unitAddress"
              @blur="getUnitAddress"
              input-align="right"
              placeholder="预算单位地址"
            />
          </div>

          <van-cell
            is-link
            :title="$t('D020','邮箱')"
            @click="EditEmailShow = true"
          >
            {{ empInfo.email || `填写邮箱有助于邮件收取` }}
          </van-cell>
        </van-cell-group>
      
        <van-cell-group class="travel-info">
          <van-cell
            is-link
            title="个人偏好"
            @click="EditPreferenceShow = true"
          >
            <div class="van-ellipsis">
              {{ empInfo.preference || `填写个人偏好(如：喜欢靠窗位置）` }}
            </div>
          </van-cell>
        </van-cell-group>
      </mescroll-vue>
    </div>

    <EditEngName :visibility.sync="EditEngNameShow" />
    <EditIdNumber :visibility.sync="EditIdNumberShow" />
    <EditPassport :visibility.sync="EditPassportShow" />
    <EditBorn :visibility.sync="EditBornShow" />
    <EditSex :visibility.sync="EditSexShow" />
    <EditEmail :visibility.sync="EditEmailShow" />
    <EditPreference :visibility.sync="EditPreferenceShow" />
    <EditNation :visibility.sync="EditNationShow" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Cell, CellGroup ,Field ,ActionSheet} from 'vant'
import { localget, localset } from 'Utils/storage'

import EditEngName from './EditEngName'
import EditIdNumber from './EditIdNumber'
import EditPassport from './EditPassport'
import EditBorn from './EditBorn'
import EditSex from './EditSex'
import EditEmail from './EditEmail'
import EditPreference from './EditPreference'
import EditNation from './EditNation'
import MescrollVue from 'mescroll.js/mescroll.vue'

export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [ActionSheet.name]: ActionSheet,
    EditEngName,
    EditIdNumber,
    EditPassport,
    EditBorn,
    EditSex,
    EditEmail,
    EditPreference,
    EditNation,
    MescrollVue
  },
  data () {
    return {
      EditEngNameShow: false,
      EditIdNumberShow: false,
      EditPassportShow: false,
      EditBornShow: false,
      EditSexShow: false,
      EditEmailShow: false,
      EditPreferenceShow: false,
      EditNationShow: false,
      down:{use:false},
      showCivil:false,//
      showCivilCheck:false,
      showBank:false,
      bankArr:[]
    }
  },
  computed: {
    ...mapState({
      empInfo: state => state.app.userInfo.empInfo,
      vipCorp: state => state.app.userInfo.vipCorp
    })
  },
  created(){
    this.init()
    this.$api['common/getBClass']({parNo: 141}).then(res=>{
      var cache=res.data||{}
      var list=cache.list||[]
      list.forEach(item=>{
        item.name=item.cName
      })
      this.bankArr=list
    })
  },
  methods:{
    init(){
      if(this.empInfo.isCivil==1){
        this.empInfo.isCivilName='是'
        if(this.empInfo.civilCheck==1){
          this.empInfo.civilCheckName='公务卡'
        }else if(this.empInfo.civilCheck==2){
          this.empInfo.civilCheckName='预算单位'
        }
      }else{
        this.empInfo.isCivilName='否'
      }
    },
    //是否公务员
    civilChange(item){
      this.empInfo.isCivil=item.key
      this.empInfo.isCivilName=item.name
      this.showCivil=false
      if(this.empInfo.isCivil==1){
        if(this.empInfo.civilCheck==1&&this.empInfo.civilBankId){
          this.save()
        }else if(this.empInfo.civilCheck==2&&this.empInfo.unitAddress){
          this.save()
        }
      }else{
        this.save()
      }
    },
    //验证方式
    civilCheckChange(item){
      this.empInfo.civilCheck=item.key
      this.empInfo.civilCheckName=item.name
      this.showCivilCheck=false
      if(this.empInfo.civilCheck==1&&this.empInfo.civilBankId){
        this.save()
      }else if(this.empInfo.civilCheck==2&&this.empInfo.unitAddress){
        this.save()
      }
    },
    //银行
    backChange(item){
      this.empInfo.civilBankId=item.id
      this.empInfo.civilBankName=item.cName
      this.showBank=false
      // this.valid()
    },
    valid(){
      if(this.empInfo.civilCheck==1){
        if(!this.empInfo.idNumber){
          this.$toast('请输入身份证号码！')
          return
        }
        this.$api['emp/gpIdValid']({
          'psgName': this.empInfo.empName,
          'civilBankId': this.empInfo.civilBankId,
          'idType':'NI',// this.empInfo.cardType,
          'idNo': this.empInfo.idNumber,
          'vcode': ''
        }).then(res=>{
          var cache=res.data||{}
          if(cache.state==0){
            this.empInfo.isCivilError='核验不通过，请核实信息是否准确。'
            this.$dialog.alert({
              title:'提示',
              message:this.empInfo.isCivilError
            })
          }else{
            this.empInfo.isCivilError=''
            this.save()
          }
        }).catch(res=>{
          this.empInfo.isCivilError=res.errMsg||'核验不通过，请核实信息是否准确。'
          this.$dialog.alert({
            title:'提示',
            message:this.empInfo.isCivilError
          })
        })
      }
    },
    //预算单位
    getUnitAddress(){
      if(this.empInfo.unitAddress){
        this.save()
      }
    },
    save() {
      let params = {
        'birthPlace': this.empInfo.birthPlace, //出生地
        'born': this.empInfo.born,
        'email': this.empInfo.email, //邮箱
        'engName': this.empInfo.engName,
        'idNumber': this.empInfo.idNumber, //身份证号码
        'nation': this.empInfo.nation,
        'oldIdNumber': this.oldIdNumber, //电话号
        'passport': this.empInfo.passport, // 护照号码
        'passportPeriod': this.empInfo.passportPeriod, //护照有效期
        'phoneNumber': this.empInfo.phoneNumber, //手机号
        'placeOfIssue': this.empInfo.placeOfIssue, //签发地
        'preference': this.empInfo.preference, // 个人偏好 ,
        'sex': this.empInfo.sex,
        civilBankId: this.empInfo.civilBankId,
        civilBankName: this.empInfo.civilBankName,
        civilCheck: this.empInfo.civilCheck,
        isCivil: this.empInfo.isCivil,
        unitAddress:this.empInfo.unitAddress
      }

      this.$api['user/vipEmpEditInfoObt'](params).then(() => {
        this.$dialog.alert({ message: '修改成功' }).then(() => {
          // 获取员工信息 
          this.$api['user/getLoginUserInfo']({
            refresh: 1
          }).then((resp2) => {
            if(resp2.data){
              this.$store.commit('SET_USERINFO', resp2.data)
              localset('userInfo', resp2.data)
            }
            this.init()
          }).catch(() => {
            console.log('failed')
          })
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.UserInfo {
  h4, h3 {
    margin: 0;
  }

  .mt5 {
    margin-top: 5px;
  }

  .travel-info {
    margin-top: 5px;

    .van-cell {
      padding: 16px;

      .van-cell__value {
        flex: 2;
      }
    }
  }
  .userInfoWrapper{
    height: calc(100vh - 46px);
    overflow: hidden;
  }
}
</style>


